import React from 'react';
import { useSelector } from 'react-redux';

import CopyButton from '../../../../components/copy-button/CopyButton';
import DataBlock from '../../predict-response/data-block/DataBlock';
import CardMark from '../../../../scout-new/components/message-card/CardMark';
import { GENIE_EVALUATE_TYPE } from '../../../../constants';

import scss from './GeneratedMessage.module.scss';

function GeneratedMessage({ message }) {
  const { messageText, count, isNew, interest, action, uncertainty, isManual, error } = message;

  const isLoading = useSelector((state) => state.genie.evaluateActions[GENIE_EVALUATE_TYPE.GENERATED].pending);

  const handleCopyText = () => {
    navigator.clipboard.writeText(messageText);
  };

  return (
    <div className={scss.message}>
      <span className={scss.idCell}>{count}</span>
      <span className={scss.textCell}>{messageText}</span>

      <DataBlock r1={interest} r2={action} certainty={uncertainty} isLoading={isLoading} error={error} />
      <CopyButton onClick={handleCopyText} />

      <CardMark isManual={isManual} isNew={isNew} />
    </div>
  );
}

export default GeneratedMessage;
